import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';

import {
    ProcessIcon,
    UserIcon,
    ListIcon,
    HomeIcon,
    TypeTempAutoIcon,
    Bulb,
} from '../../../images/icons/WrapSvg';

import PermContactCalendar from '@material-ui/icons/PermContactCalendar';
import EmployeeIcon from '@material-ui/icons/Face';
import Receipt from '@material-ui/icons/Receipt';
import Mail from '@material-ui/icons/Mail';
import Storefront from '@material-ui/icons/Storefront';
import Role from '@material-ui/icons/SupervisorAccount';

import * as actions from '../../../actions/process.inventory.actions';

import Item from './MenuItem';

class Menu extends React.Component {

    state = {
        options: [
            {
                primary: 'manage_checks_menu',
                icon: <ProcessIcon />,
                link: 'process',
                permits: [20, 62],
                licenses: [150]
            },
            {
                primary: 'manage_employees_menu',
                icon: <EmployeeIcon />,
                link: 'employees',
                permits: [20, 84],
                licenses: [150]
            },
            {
                primary: 'manage_user_menu',
                icon: <UserIcon />,
                link: 'user',
                permits: [20, 64],
                licenses: [152]
            },
            {
                primary: 'manage_catolog_menu',
                icon: <ListIcon />,
                link: 'catalogs',
                permits: [20,62],
                licenses: [150]
            },
            {
                primary: 'manage_provider_menu',
                icon: <PermContactCalendar />,
                link: 'providers',
                permits: [20,62],
                licenses: [150]
            },
            {
                primary: 'manage_reference_menu',
                icon: <Receipt />,
                link: 'references',
                permits: [20,62],
                licenses: [150]
            },
            {
                primary: 'manage_template_menu',
                icon: <Mail />,
                link: 'templates',
                permits: [20, 62],
                licenses: [151]
            },
            {
                primary: 'manage_customer_menu',
                icon: <HomeIcon />,
                link: 'customers',
                permits: [20, 65, 61],
                licenses: []
            },
            {
                primary: 'manage_display_menu',
                icon: <Bulb />,
                link: 'displays',
                permits: [20, 80],
                licenses: [156]
            },
            {
                primary: 'manage_termometre_menu',
                icon: <TypeTempAutoIcon />,
                link: 'termometres',
                permits: [20],
                licenses: [150]
            },
            {
                primary: 'locals_menu',
                icon: <Storefront />,
                link: 'locals',
                permits: [20, 81],
                licenses: [157]
            },
            {
                primary: 'roles_menu',
                icon: <Role />,
                link: 'roles',
                permits: [20, 110, 111],
                licenses: [152]
            },
        ],
    };

    handleClose = (id, url, e) => {
        this.props.setInventoryWindow(url);
        this.props.history.push('/manage/' + url);
    };

    render() {
        const { proccess_current_window, info, intl } = this.props;
        const { options } = this.state;

        const data = options
            .sort((a, b) =>
                intl.formatMessage({ id: a.primary }) < intl.formatMessage({ id: b.primary })
                    ? -1
                    : 1,
            )
            .filter(
                (f) =>
                    info &&
                    info.security &&
                    info.security.totalPermits &&
                    info.security.totalPermits.some((p) => f.permits.some((s) => s.toString() === p.toString())) &&
                    info.security.licencias.some((l) => f.licenses.length === 0 || f.licenses.some((f) => f === l.id && l.activo))
            );
        return (
            data.map((link, index) => (
                <Item
                    key={randomstring()}
                    active={proccess_current_window === link.link}
                    primary={link.primary}
                    onClick={(e) => this.handleClose(index, link.link, e)}
                    icon={link.icon}
                    last={data.length === index + 1}
                />
            ))
        );
    }
}

Menu.propTypes = {
    history: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

function mapStateToProps(state) {
    return {
        info: state.info,
        proccess_current_window: state.proccess_current_window,
    };
}

Menu = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Menu);

export default injectIntl(withRouter(Menu));



// WEBPACK FOOTER //
// ./src/components/complex/manage/Menu.js